import {
    ChangeDetectionStrategy,
    Component,
    ContentChild,
    Input,
    TemplateRef,
    ViewChild,
} from '@angular/core';

import { IconType, SafeAny } from '@pf/shared-common';
import { getNzIcon } from '../../modules/icon';

@Component({
    selector: 'pf-step',
    standalone: true,
    imports: [],
    template: `<ng-template #content><ng-content></ng-content></ng-template>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepComponent {
    @Input() title = '';
    @Input() iconType?: keyof typeof IconType;
    @Input() status?: 'wait' | 'process' | 'finish' | 'error';

    @ViewChild('content', { static: true })
    contentTemplate!: TemplateRef<SafeAny>;

    @ContentChild('stepTitle', { static: false })
    titleTemplate?: TemplateRef<SafeAny>;

    get nzIcon() {
        return getNzIcon(this.iconType) as string;
    }
}
